import cn from "classnames";
import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { kebabCase } from "lodash";

import * as styles from "./Album.module.scss";


const Album = ({ data, small, suffix }) => {
  const image = getImage(data.cover);

  return (
    <div className={cn(styles.el, {
      [styles[`elSmall`]]: small,
    })}>
      <Link to={"/" + kebabCase(`${data.number}-${data.title}`)} className={styles.link}>
        {image ?
          <GatsbyImage image={image} alt="" className={styles.cover} />
        :
          <img src={data.cover_external} alt="" className={styles.cover} />
        }
      </Link>
      <h2 className={styles.title}>
        <Link to={"/" + kebabCase(`${data.number}-${data.title}`)}>
          {data.title}
        </Link>
      </h2>
      <p className={styles.artist}>
        by {data.artist}
        {suffix && suffix}
      </p>
      <p className={styles.artist}>
      </p>
    </div>
  );
};

Album.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  small: PropTypes.bool,
  suffix: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
};

export default Album;
